import React, { useEffect, useState } from "react";
import { Container, Button, Form } from "reactstrap";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { AiFillCaretDown } from "react-icons/ai";
import { Link } from "react-router-dom";
import PointsListingModal from "../../components/Modals/PointsListingModal";
import "./wizardStep3.scss";

function WizardStep3({
  addRoute,
  previousPage,
  setWizardData,
  wizardData,
  endPointName,
  setEndPointName,
  handleSubmit,
}) {
  const [showListModal, setShowListModal] = useState(false);
  const [showClearEndPoint, setShowClearEndPoint] = useState("none");
  const [nameOfPoint, setnameOfPoint] = useState({
    name: "",
  });

  const clearEndPoint = () => {
    setWizardData({
      ...wizardData,
      endingPoint: "",
    });
    setEndPointName(null);
    setShowClearEndPoint("none");
  };

  const handleEndPoint = () => {
    setShowListModal(true);
    setnameOfPoint({
      name: "endingPoint",
    });
    // if (endPointName?.pointName === '') {
    //     setShowClearEndPoint('none');
    // } else {
    //     setShowClearEndPoint('block');
    // }
  };

  useEffect(() => {
    if (
      wizardData?.endingPoint === undefined ||
      wizardData?.endingPoint === ""
    ) {
      setShowClearEndPoint("none");
    } else {
      setShowClearEndPoint("block");
    }
  }, [wizardData?.endingPoint]);

  const handleChange = (e) => {
    setWizardData({
      ...wizardData,
      [e?.target?.name]: e?.target?.value,
    });
  };

  return (
    <div className="wizard_step step3">
      <PointsListingModal
        showListModal={showListModal}
        pointName={endPointName}
        setShowListModal={setShowListModal}
        setPointName={setEndPointName}
        setWizardData={setWizardData}
        wizardData={wizardData}
        nameOfPoint={nameOfPoint}
      />
      <Container>
        <div className="nt-wizard_step3">
          <div className="nt-wizard_step3_heading">
            <h2>Choose Where your journey ends</h2>
            <p>
              If you don't have a place decided yet, you can leave this field
              blank and proceed to ‘Add to Route.’
            </p>
          </div>
          <div className="nt-form_field">
            <Form className="nt-form_field_step3">
              <div className="nt-form_lab">
                <button
                  className="nt-clear-btn"
                  type="button"
                  style={{ display: showClearEndPoint }}
                  onClick={clearEndPoint}
                >
                  clear
                </button>
              </div>
              <div
                className="nt-form_input nt-start_input"
                onClick={handleEndPoint}
              >
                <button
                  type="button"
                  name="endingPoint"
                  id="endingPoint"
                  value={wizardData?.endingPoint}
                  onChange={handleChange}
                  onClick={handleEndPoint}
                  className="nt-add_start_point"
                >
                  {wizardData?.endingPoint ? (
                    <span className="nt-point_value">
                      {wizardData?.endingPoint}
                    </span>
                  ) : (
                    <span className="nt-point_placeholder">End Point</span>
                  )}
                </button>
                {/* <Input
                                        type="text"
                                        autoComplete="off"
                                        name="endingPoint"
                                        id="endingPoint"
                                        value={wizardData?.endingPoint}
                                        onChange={handleChange}
                                        placeholder="End Point"
                                        onClick={handleEndPoint}
                                    /> */}
                <Link className="nt-arrow" to="#">
                  <AiFillCaretDown size={11} />
                </Link>
              </div>
              <div className="nt-button">
                <Link
                  to="#"
                  type="button"
                  onClick={previousPage}
                  className="nt-back-button"
                >
                  <MdOutlineKeyboardBackspace size={24} />
                  <span>Back</span>
                </Link>
                <Button type="button" onClick={handleSubmit}>
                  Add to route
                </Button>
              </div>
            </Form>
          </div>
        </div>
        {/* <Row>
          <Col className="bg-light step_section">
            <ul>
              <li>
                Now if you have finalized a destination where you wish to end
                the planned route, you can add it here.
              </li>
              <li>
                You don't have the place decided yet you can leave the field
                blank and proceed to add this new route.
              </li>
            </ul>
            <div className="form_field">
              <Form>
                <div className="form_lab">
                  <Label>End Point</Label>
                  <button
                    className="clear-btn"
                    type="button"
                    style={{ display: showClearEndPoint }}
                    onClick={clearEndPoint}
                  >
                    clear
                  </button>
                </div>
                <div className="form_input start_input">
                  <Button
                    name="endingPoint"
                    id="endingPoint"
                    value={wizardData?.endingPoint}
                    onChange={handleChange}
                    onClick={handleEndPoint}
                    className="add_start_point"
                  >
                    {wizardData?.endingPoint ? (
                      <span className="point_value">
                        {wizardData?.endingPoint}
                      </span>
                    ) : (
                      <span className="point_placeholder">End Point</span>
                    )}
                  </Button>
                  <Input
                                        type="text"
                                        autoComplete="off"
                                        name="endingPoint"
                                        id="endingPoint"
                                        value={wizardData?.endingPoint}
                                        onChange={handleChange}
                                        placeholder="End Point"
                                        onClick={handleEndPoint}
                                    />
                  <Link className="arrow" to="#" onClick={handleEndPoint}>
                    <AiFillCaretDown />
                  </Link>
                </div>
                <div className="button">
                  <Link to="#" type="button" onClick={previousPage}>
                    <MdOutlineKeyboardBackspace size={24} />
                    Back
                  </Link>
                  <Button type="button" onClick={handleSubmit}>
                    Add to route
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row> */}
      </Container>
    </div>
  );
}

export default WizardStep3;
